import { useState } from "react";

import type { FilterConfig } from "../../../api/posterService";

import { AppearancePresetPanel } from "./AppearancePresetPanel";

/**
 * 详情页"画面" Tab —— 实际工作交给 AppearancePresetPanel(同组件 Step6 也用)。
 * 内部维护 mode 切换 state,默认普通模式。
 */
export interface AppearanceTabProps {
  filter: FilterConfig;
  onChange: (next: FilterConfig) => void;
}

export function AppearanceTab({ filter, onChange }: AppearanceTabProps) {
  const [mode, setMode] = useState<"simple" | "advanced">("simple");
  return (
    <div className="pt-2">
      <AppearancePresetPanel
        filter={filter}
        mode={mode}
        onModeChange={setMode}
        onChange={onChange}
      />
    </div>
  );
}
